import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { LeadCaptureProvider } from '../../context/LeadCaptureContext';
import './layout.css';

const LandingLayout = ({ children }) => {
  return (
    <LeadCaptureProvider>
      <Header />
      <div className="child-wrapper">{children}</div>
      <Footer />
    </LeadCaptureProvider>
  );
};

export default LandingLayout;
